import { parseJalaliDateStringToDate } from '@/modules/Reminder/utils/jalaliCalendar'
import { toEnglishDigits } from '@/modules/Core/utils/convertFaToEnNumbers'

const TEHRAN_TIME_ZONE = 'Asia/Tehran'

export const JALALI_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  calendar: 'persian',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: TEHRAN_TIME_ZONE,
}

export const JALALI_DATE_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  ...JALALI_DATE_FORMAT_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
}

const JALALI_YEAR_MIN = 1300
const JALALI_YEAR_MAX = 1500
const GREGORIAN_YEAR_MIN = 1900
const GREGORIAN_YEAR_MAX = 2100

function parseGregorianDateOnly(value: string): Date | null {
  const normalized = toEnglishDigits(value).trim()
  const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/)

  if (!match) {
    return null
  }

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])

  if (year < GREGORIAN_YEAR_MIN || year > GREGORIAN_YEAR_MAX) {
    return null
  }

  return new Date(year, month - 1, day)
}

function parseJalaliDateOnlyForDisplay(value: string): Date | null {
  const normalized = toEnglishDigits(value).trim()
  const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/)

  if (!match) {
    return parseJalaliDateStringToDate(value)
  }

  const year = Number(match[1])

  if (year >= JALALI_YEAR_MIN && year <= JALALI_YEAR_MAX) {
    return parseJalaliDateStringToDate(value)
  }

  return null
}

export function parseDateForDisplay(value: string): Date | null {
  if (!value?.trim()) {
    return null
  }

  const trimmed = value.trim()

  const jalaliDate = parseJalaliDateOnlyForDisplay(trimmed)
  if (jalaliDate) {
    return jalaliDate
  }

  const gregorianDateOnly = parseGregorianDateOnly(trimmed)
  if (gregorianDateOnly) {
    return gregorianDateOnly
  }

  const parsed = new Date(trimmed)
  if (Number.isNaN(parsed.getTime())) {
    return null
  }

  return parsed
}

export function formatJalaliDateFromDate(date: Date): string {
  return date.toLocaleDateString('fa-IR', JALALI_DATE_FORMAT_OPTIONS)
}

export function formatJalaliDateTimeFromDate(date: Date): string {
  return date.toLocaleString('fa-IR', JALALI_DATE_TIME_FORMAT_OPTIONS)
}

export function formattedJalaliDate(date: string) {
  const parsed = parseDateForDisplay(date)

  if (!parsed) {
    return '—'
  }

  return formatJalaliDateFromDate(parsed)
}

export function formattedJalaliDateTime(date: string) {
  const parsed = parseDateForDisplay(date)

  if (!parsed) {
    return '—'
  }

  return formatJalaliDateTimeFromDate(parsed)
}
